import React, { useState } from 'react'
import { Tabs, DatePicker, Badge, Spin, message } from 'antd'
import type { TabsProps } from 'antd'
import OrderCard from './OrderCard'
import { useRequest } from '@sisyphe/hooks'
import * as api from 'services/order'
import dayjs from 'dayjs'
import './index.less'

const formatter = 'YYYY-MM-DD HH:mm:ss'

type Props = {}

const items = ({ WAITDELIVER, NOT_RECEIVED }): TabsProps['items'] => [
  {
    key: '',
    label: `全部订单`,
  },
  {
    key: '0',
    label: (
      <Badge count={WAITDELIVER} size="small" color="#E21D1D">
        <span>待发货</span>
      </Badge>
    ),
  },
  {
    key: '5',
    label: (
      <Badge count={NOT_RECEIVED} size="small" color="#E21D1D">
        <span>待收货</span>
      </Badge>
    ),
  },
]

const getTimeRange = time => {
  let createTimeStart = time
    ? dayjs(time[0]).startOf('day').format(formatter)
    : ''
  let createTimeEnd = time ? dayjs(time[1]).endOf('day').format(formatter) : ''
  return { createTimeStart, createTimeEnd }
}

const Order = (props: Props) => {
  const [time, setTime] = useState<any>()
  const [activeKey, setActiveKey] = useState(undefined)

  /**我的订单-分页查询-订单集合 */
  const {
    run: queryMyOrdersUsingPOST,
    data: list,
    loading,
  } = useRequest(async (payload = {}) => {
    const params = {
      ...getTimeRange(time),
      pageNum: 1,
      pageSize: 99999,
      status: activeKey,
      ...payload,
    }
    const { data } = await api.queryMyOrdersUsingPOST(params)
    return data?.records
  })

  /**我的订单-分页查询-订单状态数量统计 */
  const { run: queryMyOrderCountUsingPOST, data: statistics } = useRequest(
    async () => {
      const params = {
        ...getTimeRange(time),
        pageNum: 1,
        pageSize: 99999,
        status: activeKey!,
      }
      const { data } = await api.queryMyOrderCountUsingPOST(params)
      let WAITDELIVER = 0
      let NOT_RECEIVED = 0

      data.forEach(item => {
        !item.status && (WAITDELIVER = item.orderCount)
        item.status === 5 && (NOT_RECEIVED = item.orderCount)
      })
      return { WAITDELIVER, NOT_RECEIVED }
    }
  )

  /**我的订单-确认收货 */
  const { run: confirmReceiptUsingPOST } = useRequest(
    async orderNo => {
      await api.confirmReceiptUsingPOST({ orderNo })
      message.success('操作成功')
      queryMyOrdersUsingPOST()
      queryMyOrderCountUsingPOST()
    },
    { manual: true }
  )

  const tabsChange = e => {
    setActiveKey(e)
    queryMyOrdersUsingPOST({ status: e && +e })
    queryMyOrderCountUsingPOST()
  }

  return (
    <div className="order">
      <Tabs
        defaultActiveKey=""
        activeKey={activeKey}
        items={items(statistics! || {})}
        onChange={tabsChange}
        tabBarExtraContent={
          <div className="tabBarExtraContent">
            <span className="label">下单时间: </span>
            <DatePicker.RangePicker
              className="range-picker"
              value={time}
              onChange={e => {
                setTime(e)
                queryMyOrdersUsingPOST({ ...getTimeRange(e) })
              }}
            />
          </div>
        }
      />
      <Spin spinning={loading}>
        <OrderCard dataSource={list} receiptHandle={confirmReceiptUsingPOST} />
      </Spin>
    </div>
  )
}

export default Order
